import React from "react";
import ReactDOM from "react-dom/client";
import "./components/css/index.css";
import reportWebVitals from "./reportWebVitals";
import VotingGrid from "./components/VotingGrid.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <VotingGrid />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
